import { useCallback, useState } from "react";
import constate from "constate";

export enum ErrorLevel {
  Error,
  Info,
}

export type GlobalError = {
  title: string;
  message: string;
  handlerText: string;
  onClearError?: () => void;
  level?: ErrorLevel; // default to error
};

export const useGlobalErrorManager = () => {
  const [error, setError] = useState<null | GlobalError>(null);

  const { onClearError } = error || {};
  const clearError = useCallback(() => {
    setError(null);
    if (onClearError) {
      onClearError();
    }
  }, [onClearError]);

  return {
    error,
    setError,
    clearError,
  };
};

export const [GlobalErrorProvider, useGlobalError] = constate(
  useGlobalErrorManager,
);
